import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'owl-carousel-child',
  template: '<ng-content></ng-content>',
  standalone: false
})
export class OwlChild implements OnInit, OnDestroy {
  @HostBinding('class.owl-carousel') owlClass: any = true;
  $owl: any;
  @Input() options: any = {};
  currentSlideIndex!: number;

  constructor(private el: ElementRef) {
    if (typeof $ === 'undefined' && typeof jQuery !== 'undefined') {
      $ = jQuery;
    }
  }

  ngOnInit(): void {
    if ((typeof window !== 'undefined') && $ && typeof $.fn.owlCarousel === 'function') {
      this.$owl = $(this.el.nativeElement);
    }
  }

  ngAfterViewInit(): void {
    this.initOwl();
  }

  initOwl(): void {
    if (this.$owl) {
      const options: any = {};
      Object.assign(options, this.options);
      if (this.currentSlideIndex) {
        options.startPosition = this.currentSlideIndex;
      }
      this.$owl.owlCarousel(options);
      this.$owl.on('changed.owl.carousel', (event: any) => {
        this.currentSlideIndex = event.item.index;
      });
    }
  }

  trigger(action: string, options?: any[]): void {
    if (this.$owl) {
      this.$owl.trigger(action, options);
    }
  }

  ngOnDestroy(): void {
    this.destroyOwl();
    delete this.$owl;
  }

  destroyOwl(): void {
    if (this.$owl) {
      this.$owl.trigger('destroy.owl.carousel')
        .removeClass('owl-loaded owl-hidden')
        .find('.owl-stage:empty, .owl-item:empty')
        .remove();
    }
  }
}
